if (!customElements.get('box-customiser')) {
  customElements.define(
    'box-customiser',
    class BoxCustomiser extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;

        this.initialised = true;
        this.required = Number.parseInt(this.dataset.required, 10);
        this.form = document.getElementById(this.dataset.formId);
        this.options = [...this.querySelectorAll('[data-box-option]')];
        this.standardPanel = this.querySelector('[data-standard-panel]');
        this.customPanel = this.querySelector('[data-custom-panel]');
        this.modeInput = this.querySelector('[data-box-mode-input]');
        this.count = this.querySelector('[data-box-count]');
        this.bar = this.querySelector('[data-box-bar]');
        this.hint = this.querySelector('[data-box-hint]');
        this.summary = this.querySelector('[data-box-summary]');

        if (!this.form || !Number.isFinite(this.required)) return;

        this.submitButton = this.form.querySelector('[name="add"]');
        this.dynamicCheckout = this.form.querySelector('.product-form__dynamic-checkout');
        this.productUnavailable = this.submitButton?.disabled ?? true;

        this.querySelectorAll('[data-box-mode]').forEach((button) => {
          button.addEventListener('click', () => this.setMode(button.dataset.boxMode));
        });

        this.options.forEach((option) => {
          option.querySelector('[data-box-decrease]').addEventListener('click', () => this.changeQuantity(option, -1));
          option.querySelector('[data-box-increase]').addEventListener('click', () => this.changeQuantity(option, 1));
        });

        this.setMode('standard');
      }

      setMode(mode) {
        this.mode = mode;
        const customising = mode === 'customise';

        this.querySelectorAll('[data-box-mode]').forEach((button) => {
          const active = button.dataset.boxMode === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        this.standardPanel.hidden = customising;
        this.customPanel.hidden = !customising;
        this.modeInput.value = customising ? 'Customised box' : 'Standard box';

        this.resetToDefaults();
        this.update();
      }

      resetToDefaults() {
        this.options.forEach((option) => {
          this.setQuantity(option, Number.parseInt(option.dataset.default, 10) || 0);
        });
      }

      changeQuantity(option, delta) {
        const current = this.getQuantity(option);

        if (delta > 0 && this.totalSelected() >= this.required) {
          this.showLimitHint();
          return;
        }

        this.setQuantity(option, Math.max(0, current + delta));
        this.update();
      }

      getQuantity(option) {
        return Number.parseInt(option.querySelector('[data-box-property]').value, 10) || 0;
      }

      setQuantity(option, quantity) {
        const input = option.querySelector('[data-box-property]');

        input.value = quantity;
        input.disabled = quantity === 0;
        option.querySelector('[data-box-quantity]').textContent = quantity;
        option.querySelector('[data-box-decrease]').disabled = quantity === 0;
        option.classList.toggle('has-quantity', quantity > 0);
      }

      totalSelected() {
        return this.options.reduce((total, option) => total + this.getQuantity(option), 0);
      }

      update() {
        const total = this.totalSelected();
        const valid = this.mode === 'standard' || total === this.required;
        const percentage = Math.min(100, (total / this.required) * 100);

        this.count.textContent = `${total} / ${this.required} selected`;
        this.count.classList.toggle('is-complete', total === this.required);
        this.bar.classList.toggle('is-complete', total === this.required);
        this.bar.querySelector('span').style.width = `${percentage}%`;
        this.hint.hidden = valid;

        this.options.forEach((option) => {
          option.querySelector('[data-box-increase]').disabled = total >= this.required;
        });

        this.updateSummary();
        this.updateSubmitState(valid);
      }

      updateSummary() {
        this.summary.replaceChildren();

        this.options.forEach((option) => {
          const quantity = this.getQuantity(option);
          if (quantity === 0) return;

          const item = document.createElement('li');
          const label = option.querySelector('.box-customiser__option-name').textContent;
          item.textContent = `${quantity} × ${label}`;
          this.summary.appendChild(item);
        });

        if (!this.summary.children.length) {
          const item = document.createElement('li');
          item.textContent = 'No mince or sausages selected yet';
          this.summary.appendChild(item);
        }
      }

      updateSubmitState(valid) {
        if (!this.submitButton) return;

        const disabled = this.productUnavailable || !valid;
        this.submitButton.disabled = disabled;
        this.submitButton.toggleAttribute('aria-disabled', disabled);

        if (this.dynamicCheckout) {
          this.dynamicCheckout.hidden = !valid;
        }
      }

      showLimitHint() {
        this.hint.hidden = false;
        this.hint.textContent = `You’ve already used all ${this.required} customisable slots. Remove one to add another.`;

        window.clearTimeout(this.hintTimer);
        this.hintTimer = window.setTimeout(() => {
          this.hint.textContent = `Please select exactly ${this.required} mince/sausage items.`;
          this.hint.hidden = this.totalSelected() === this.required;
        }, 2500);
      }
    }
  );
}
